<template>
  <div class="tab-pane active" id="whatsapp-stats">
    <div class="card-body">
      <div class="row mb-4">
        <div class="col-lg-6">
          <status-messages-chart
            ref="statusMessages"
            :startDate="this.startDate"
            :endDate="this.endDate"
            :filter="this.filters"
          />
        </div>
        <div class="col-lg block-el">
          <!-- <div v-if="loading" class="qt-block-ui" /> -->
          <div class="loading min-h-300" v-if="loading">
            <LoadingAnim />
          </div>
          <template v-else>
            <div class="row enviadas stats-column-right pr-5">
              <div class="card card-messages card-second-row inner-card">
                <div class="card-body">
                  <Tarifada />
                  <p class="card-text">Tarifadas</p>
                  <span class="card-text">{{ charged }}</span>
                </div>
              </div>
              <div id="infos-top" class="card card-messages">
                <div class="card-body">
                  <LottieAnimMsgGreen />
                  <p class="card-text">Mensagem Enviadas</p>
                  <span class="card-text">{{ outbound }}</span>
                </div>
              </div>
            </div>
            <div class="row recebidas stats-column-right pr-5">
              <div class="card card-messages card-second-row inner-card">
                <div class="card-body">
                  <Fail />
                  <p class="card-text">Falhas</p>
                  <span class="card-text">{{ failures }}</span>
                </div>
              </div>
              <div id="infos-bottom" class="card card-messages">
                <div class="card-body">
                  <LottieAnimMsgPurple />
                  <p class="card-text">Mensagem Recebidas</p>
                  <span class="card-text">{{ inbound }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
<!--  <div class="row">
        <div class="col-sm-12">
          <whats-app-jv-report :dateGte="filters.gte" :dateLte="filters.lte" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatusMessagesChart from '@/components/rebranding/whatsappj/StatusMessagesChart.vue';
import LottieAnimMsgGreen from '@/components/rebranding/animLottie/MsgGreen.vue';
import LottieAnimMsgPurple from '@/components/rebranding/animLottie/MsgPurple.vue';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';
import Fail from '@/components/rebranding/animLottie/Fail.vue';
import axios from '@/plugins/axios';
import Tarifada from '@/components/rebranding/animLottie/Tarifada.vue';
import WhatsAppJvReport from '@/components/rebranding/whatsappj/insights/ReportList.vue';
import moment from 'moment';

const webApi = axios();

export default {
  name: 'WhatsappStats',
  components: {
    StatusMessagesChart,
    LottieAnimMsgGreen,
    LottieAnimMsgPurple,
    LoadingAnim,
    Fail,
    Tarifada,
    // WhatsAppJvReport,
  },
  props: {
    filters: {
      type: Object,
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      inbound: 0,
      outbound: 0,
      failures: 0,
      charged: 0,
    };
  },
  mounted() {
    this.fetch();
  },
  computed: {
    timeWindow() {
      if (moment(this.endDate).diff(moment(this.startDate), 'days')) {
        return 'day';
      }
      return 'hour';
    },
    account() {
      return this.$store?.state?.account;
    },
  },
  methods: {
    fetch() {
      const id = (this.filters.account_id.in && this.filters.account_id.in.length > 0) ? this.filters.account_id.in : this.$store.state.account.id; // Get account id from props else set own account id.
      const filterParam = {
        account_id: id,
        start_date: new Date(this.filters.gte).toISOString(),
        end_date: new Date(this.filters.lte).toISOString(),
        time_window: this.timeWindow,
        group_by: 'status',
        filter: {
          status: [],
        },
      };
      // this.fetchDiretionalMessages(this.filters);
      // this.fetchTariffedMessages(this.filters);
      // this.$refs.carrierMessages.fetch(this.filters);
      if (this.filters.campaign) {
        filterParam.campaign_ext_id = this.filters.campaign;
      }

      if (this.filters.status && this.filters.status.length > 0) {
        filterParam.filter.status = this.filters.status.map((value) => value.toUpperCase());
      } else {
        delete filterParam.filter;
      }

      this.loading = true;
      webApi.post('/whatsapp/new/insights-count', filterParam).then((response) => {
        this.inbound = response.data.received;
        this.outbound = response.data.sent;
        this.failures = response.data.failed;
        this.charged = response.data.sessions;
        this.loading = false;
      }, (error) => {
        this.$toast.show({
          title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
          content: error.message,
          type: 'danger',
        });
        this.loading = false;
      });

      this.$refs.statusMessages.fetch(this.filters);
    },
    fetchDiretionalMessages(filter) {
      this.$store
        .dispatch('fetchWhatsappInsights', {
          start_date: this.startDate,
          end_date: this.endDate,
          group_by: 'direction',
          filter,
        })
        .then((response) => {
          this.loading = false;
          this.inbound = response.inbound;
          this.outbound = response.outbound;
        });
    },
    fetchTariffedMessages(filter) {
      this.charged = 0;
      this.$store
        .dispatch('fetchWhatsappInsights', {
          start_date: this.startDate,
          end_date: this.endDate,
          group_by: 'status',
          filter,
        })
        .then((response) => {
          this.loading = false;
          Object.entries(response).forEach((status) => {
            if (status[0] === 'failed') {
              this.failures = status[1];
            } else {
              this.charged += status[1];
            }
          });
        });
    },
    exportData(format) {
      this.loading = true;

      webApi.post('/whatsapp/new/report/generate', {
        from: this.filters.gte,
        to: this.filters.lte,
        format,
      }).then((response) => {
        console.log('Export');
        console.log(response);
        this.loading = false;
        this.$router.push('/whatsapp/jv/reports/exports');
      }, (error) => {
        this.loading = false;
        this.content = error;
        this.$toast.show({
          title: 'Erro',
          content: 'Erro interno, por favor tente novamente mais tarde ou contact o suporte para ajuda.',
          type: 'error',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stats-column-right {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-end;
}
.card-messages {
  /* margin-left: auto; */
  max-height: 230px;

  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      color: var(--clr-light-2);
      font-weight: bold;
    }
  }
}
#infos-bottom,
#infos-top {
  position: relative;
  z-index: 1;
  min-width: 260px;
}
.card-messages.inner-card {
  /* position: absolute;
  right: 0; */
  /* opacity: 0; */
  z-index: 1;
}
.card-messages.inner-card.active {
  /* position: absolute;
  right: 325px; */
  z-index: 0;
  /* opacity: 1; */
}
/* .card-messages.inner-card.active:last-of-type {
  right: 470px;
} */

.darkmode .card {
  background-color: var(--background-3);
}
</style>
